import React, { createContext, ReactNode, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import useCookie from 'react-use-cookie';

interface Props {
    measurementId: string,
    children: ReactNode
}

export interface IGoogleAnalyticsContext {
    trackEvent: (name: string) => void
}

const GoogleAnalyticsContext = createContext({
    trackEvent: () => {}
} as IGoogleAnalyticsContext);

const GoogleAnalyticsProvider : React.FC<Props> = ({measurementId, children}) => {
    const {pathname} = useLocation();
    const [analyticsConsent] = useCookie('consent_analytics');

    useEffect(() => {
        if(analyticsConsent === "1" && measurementId) {
            console.log("Init GA");
            ReactGA.initialize(measurementId);
        }
    }, [analyticsConsent, measurementId]);

    useEffect(() => {
        if(analyticsConsent === "1") {
            ReactGA.send({hitType: 'pageview', pagename: pathname});
        }
    }, [pathname, analyticsConsent]);


    const trackEvent = (name: string) => {
        if(analyticsConsent === "1") {
            ReactGA.send({hitType: 'click', action: `click_${name}`, pagename: pathname});
        }

    }

    return <GoogleAnalyticsContext.Provider value={{
        trackEvent
    }}>{children}</GoogleAnalyticsContext.Provider>
}

export default GoogleAnalyticsProvider;